import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { ButtonDeleteConfirm } from '@framework/ui/components/button/ButtonDeleteConfirm.tsx';
import { message } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useRemoveSubmissionManager } from '../hooks/useRemoveSubmissionManager.ts';

export interface IRemoveSubmissionAttorneyButtonProps {
  submissionId: string | null;
  disabled?: boolean;
  iconOnly?: boolean;
}

export function RemoveSubmissionAttorneyButton(
  props: IRemoveSubmissionAttorneyButtonProps,
) {
  const { submissionId, disabled, iconOnly } = props;
  const { t } = useTranslation();
  const { remove } = useRemoveSubmissionManager();
  const handleRemove = useCallback(async () => {
    if (!submissionId) {
      console.error('No submissionId');
      return;
    }
    try {
      await remove.mutateAsync(submissionId);
      message.success(
        t(
          'remove-submission-attorney-button.procuratore-rimosso-con-successo',
          'Procuratore rimosso con successo',
        ),
      );
    } catch (e) {
      console.error(e);
      // biome-ignore format: <tbd>
      message.error(getNetworkErrorMessage(e, t("remove-submission-attorney-button.errore", 'Si è verificato un errore. Riprovare.')));
    }
  }, [remove, submissionId, t]);
  return (
    <ButtonDeleteConfirm
      size="middle"
      tooltip={
        iconOnly
          ? t(
              'remove-submission-attorney-button.rimuovi-procuratore',
              'Rimuovi Procuratore',
            )
          : undefined
      }
      title={t(
        'remove-submission-attorney-button.rimuovere-attuale-procuratore',
        "Rimuovere l'attuale procuratore?",
      )}
      onConfirm={handleRemove}
      disabled={disabled}
      buttonType={iconOnly ? 'link' : 'default'}
      iconOnlyButton={iconOnly}
    >
      {iconOnly
        ? null
        : t(
            'remove-submission-attorney-button.rimuovi-procuratore',
            'Rimuovi Procuratore',
          )}
    </ButtonDeleteConfirm>
  );
}
